import React, {useState} from 'react';
import Button from "@material-ui/core/Button";
import {useDispatch, useSelector} from "react-redux";
import {
    addTagAddDomainsNotApplicable, addTagAddIdentitiesNotApplicable,
    addTagAddIpsNotApplicable,
    addTagCloudIntegrationNotApplicable,
    addTagForOnboardingProgress
} from "../../../actions";
import {Dialog, DialogContent, DialogTitle} from "@mui/material";
import {Col, Row} from "reactstrap";
import DialogContentText from "@material-ui/core/DialogContentText";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import BBExternalLink from "../accents/BBExternalLink";
import {BRCustomizedTooltip} from "../accents/BRCustomizedTooltip";


const OnboardingItemNotApplicableButton = ({progressItem = null, text = null, }) =>{

    const { entityInView, selfEntityId} = useSelector(({breachrisk}) => breachrisk);
    const {customers, customerInView, loadingCustomers} = useSelector(({customer})=> customer);

    const [openITElementsDialog, setOpenITElementsDialog] = useState(false);
    const [openCloudIntegrationsDialog, setOpenCloudIntegrationsDialog] = useState(false);

    const dispatch = useDispatch();
    console.log("progressItem", progressItem, )

    const handleClick = ()=> {
        console.log('handleClick')
        if (progressItem === "enabledCloudIntegrations"){
            console.log("openCloudIntegrationsDialog", openCloudIntegrationsDialog)
            setOpenCloudIntegrationsDialog(true);
        } else{
            console.log("openItElementsDialog", openITElementsDialog)
            setOpenITElementsDialog(true);
        }
    }

    const markNA = ()=>{
        switch (progressItem) {
            case "ipsNA":
                dispatch(addTagAddIpsNotApplicable(customerInView, entityInView))
                setOpenITElementsDialog(false)
                break
            case "domainsNA":
                dispatch(addTagAddDomainsNotApplicable(customerInView, entityInView))
                setOpenITElementsDialog(false)
                break
            case "enabledCloudIntegrations":
                dispatch(addTagCloudIntegrationNotApplicable(customerInView, entityInView))
                setOpenCloudIntegrationsDialog(false)
                break
            case "identitiesNA":
                dispatch(addTagAddIdentitiesNotApplicable(customerInView, entityInView))
                setOpenITElementsDialog(false)
                break

            default:
                console.error("progressItem did not match any case, nothing sent")
        }
    }

    const cloudIntegrationsDialog = <Dialog open={openCloudIntegrationsDialog}
                    maxWidth={"md"}
                    fullWidth={true}
                    // onClose={setOpenCloudIntegrationsDialog(false)}
                    aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="customized-dialog-title">
                    <Row>
                        <Col lg={11}>
                            <h1>
                                Not Using the Cloud?
                            </h1>
                        </Col>
                        <Col lg={1} className={"text-right align-self-center d-print-none"}>
                            <IconButton
                                onClick={()=>setOpenCloudIntegrationsDialog(false)}
                                className={"close"}>
                                <CloseIcon/>
                            </IconButton>
                        </Col>
                    </Row>
                </DialogTitle>
        <DialogContent className={"px-2 mx-2 text-center"}>
            <DialogContentText className={"p-2"}>
                <Row>
                    <Col>
                        <p>Integrating BreachRisk&trade; into your cloud infrastructure is the easiest way to ensure continuous updates and verifications.</p>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <p>If you're confident that your company is not using any cloud services, you can mark it as "Not Applicable" using the button below.</p>
                    </Col>
                </Row>
                <Row className={"text-right"}>
                    <Col>
                        <Button variant={"contained"}
                                onClick={()=>markNA("cloudIntegrationsNA")}>
                            No Cloud Infrastructure To Add
                        </Button>
                    </Col>
                </Row>

                    </DialogContentText>
                </DialogContent>
            </Dialog>

    const itElementsDialog = <Dialog open={openITElementsDialog}
                                     maxWidth={"md"}
                                     fullWidth={true}
                                     // onClose={setOpenITElementsDialog(false)}
                                     aria-labelledby="form-dialog-title"
    >
        <DialogTitle id="customized-dialog-title">
            <Row>
                <Col lg={11} className={"text-center"}>
                    <h1>
                        No {progressItem == 'ipsNA'
                        ? "IPs"
                        : progressItem === "domainsNA"
                            ? "Domains"
                            : progressItem === "identitiesNA"
                                ? "Identities"
                                : "IT Elements"} To Add?
                    </h1>
                </Col>
                <Col lg={1} className={"text-right align-self-center d-print-none"}>
                    <IconButton
                        onClick={()=>setOpenITElementsDialog(false)}
                        className={"close"}>
                        <CloseIcon/>
                    </IconButton>
                </Col>
            </Row>
        </DialogTitle>
        <DialogContent className={"px-2 mx-2 text-center"}>
            <DialogContentText className={"p-2"}>
                <Row>
                    <Col>
                        Add all of your public-facing resources to BreachRisk™ for Business to increase the fidelity of your results and avoid surprises. Learn more about how to
                        add these elements and why by visiting our <BBExternalLink tipText={"This link opens a separate tab to our knowledge base."} href={"https://support.breachbits.com/knowledge/add-and-manage-infrastructure"}>Knowledge Base.</BBExternalLink>
                    </Col>
                </Row>
                <br/>
                <Row>
                    <Col>
                        <p>
                            If you're confident there are no additional {progressItem == 'ipsNA'
                            ? "IPs"
                            : progressItem === "domainsNA"
                                ? "Domains"
                                : progressItem === "identitiesNA"
                                    ? "Identities"
                                    : "IT Elements"} you can mark them "Not Applicable" using the buttons below.
                        </p>
                    </Col>
                </Row>
                <br/>
                <Row className={"mt-1 pt-1 text-right"}>
                    <Col sm={12} lg={12} className={"float-right"}>
                        <Button variant={"contained"}
                                onClick={()=>markNA()}>
                            {progressItem == 'ipsNA'
                                ? "No IPs To Add"
                                : progressItem === "domainsNA"
                                    ? "No Domains To Add"
                                    : progressItem === "identitiesNA"
                            ? "No Identities To Add"
                            : "Not Applicable"}
                        </Button>
                    </Col>
                    {/*<Col>*/}
                    {/*    <Button variant={"contained"}*/}
                    {/*            onClick={()=>markNA("domainsNA")}>*/}
                    {/*        No Domains To Add*/}
                    {/*    </Button>*/}
                    {/*</Col>*/}
                    {/*<Col>*/}
                    {/*    <Button variant={"contained"}*/}
                    {/*            onClick={()=>markNA("identitiesNA")}>*/}
                    {/*        No Identities To Add*/}
                    {/*    </Button>*/}
                    {/*</Col>*/}
                </Row>

            </DialogContentText>
        </DialogContent>
    </Dialog>

    // const dialog = progressItem && progressItem === "hasAddedITElements" ? itElementsDialog : progressItem === "enabledCloudIntegrations" ? cloudIntegrationsDialog : null;

    return(
        <>
            <BRCustomizedTooltip title={"If this task does not apply to your company, you can mark it by clicking here."}>
            <p className={"text-decoration-underline text-blue"}
                    onClick={()=>handleClick()}
               style={{cursor: "pointer"}}>
                <em>{text ? text : "Not Applicable"}</em>
            </p>
            </BRCustomizedTooltip>

            {itElementsDialog}
            {cloudIntegrationsDialog}

        </>

    )

}

export default OnboardingItemNotApplicableButton